import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const getReceiptInvoice = (state) => {
  return axios.get(API + "receipts/receiptInvoices/"+state+"/",{headers: authHeader(),});
};
const getReceiptInvoicepaid = (state) => {
  return axios.get(API + "receipts/receiptInvoicespaid/"+state+"/",{headers: authHeader(),});
};
const getReceiptpaid = (state) => {
  return axios.get(API + "receipts/invoicereceipts/"+state+"/",{headers: authHeader(),});
};

const getReceiptDetail = (state) => {
  return axios.get(API + "receipts/create/receipts/?receipt_id="+state,{headers: authHeader(),});
};
const updateReceipt = (receipt_number, receipt_date, receipt_amount,customer_id, contract_id,remittance_bank,receipt_method,receipt_reference,status,comments,overide_application,attribute) => {
    return axios.post(API + "receipts/create/receipts/", {
      receipt_number,
      receipt_date,
      receipt_amount,
      customer_id,
      contract_id,
      remittance_bank,
      receipt_method,
      receipt_reference,
      status,
      comments,
      overide_application,
      attribute
    },{headers: authHeader(),});
  };

  const updateReceiptstatus = (state,receipt_number, receipt_date, receipt_amount,customer_id, contract_id,remittance_bank,receipt_method,receipt_reference,status,overide_application,attribute) => {
    return axios.post(API + "receipts/statusupdate/receipts/", {
      state,
      receipt_number,
      receipt_date,
      receipt_amount,
      customer_id,
      contract_id,
      remittance_bank,
      receipt_method,
      receipt_reference,
      status,
      overide_application,
      attribute
    },{headers: authHeader(),});
  };
  
const EditReceiptService = {
    getReceiptDetail,
    updateReceipt,
    getReceiptInvoice,
    getReceiptInvoicepaid,
    getReceiptpaid,
    updateReceiptstatus
    };
export default EditReceiptService;